import styles from "./index.module.scss";
import { IconMoreLine, MoreSvg } from "@/assets/icons";
import { MoreMenu } from "@/components";
import clsx from "clsx";
import { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";

const MoreButton = () => {
  const { t } = useTranslation();
  const [menuVisible, setMenuVisible] = useState<boolean>(false);
  const timeoutIdRef = useRef<any>();
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const [menuPosition, setMenuPosition] = useState({ left: 0, bottom: 0 });
  useEffect(() => {
    const rect = buttonRef.current?.getBoundingClientRect();
    if (rect) {
      const { left, width, bottom } = rect;
      const menuLeft = left + width + 10;;
      const menuBottom = window.innerHeight - (bottom);
      setMenuPosition({ left: menuLeft, bottom: menuBottom });

    }
  }, [])
  const handleMouseEnter = () => {
    clearTimeout(timeoutIdRef.current);
    setMenuVisible(true);
  };

  const handleMouseLeave = () => {
    timeoutIdRef.current = setTimeout(() => {
      setMenuVisible(false);
    }, 500);
  };

  return (
    <button
      className={clsx(styles["more_button"])}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={buttonRef}
    >
      <span className={styles.icon}><IconMoreLine /></span>
      <span className={styles.text}>{t("left_slider_more")}</span>

      {menuVisible &&
        ReactDOM.createPortal(
          <div className={styles["more_menu_wrapper"]} style={{
            position: "fixed",
            left: menuPosition.left,
            bottom: menuPosition.bottom,
            zIndex: 1000
          }}>
            <MoreMenu></MoreMenu>
          </div>,
          document.body
        )}
    </button>
  );
};

export default MoreButton;
